import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    CompletionsRequestState,
    selectAllCompletion,
    selectCompletionStatus,
} from "@Store/Reducers/completions";
import NotificationActions from "@Store/Reducers/notifications/actions";

const EMPTY_CHOICES: string[] = [];

const useSuggestedChoices = (): [string?, Array<string>?] => {
    const autocomplations = useSelector(selectAllCompletion) || EMPTY_CHOICES;
    const status =
        useSelector(selectCompletionStatus) || CompletionsRequestState.IDLE;
    const dispatch = useDispatch<any>();

    useEffect(() => {
        if (status === CompletionsRequestState.FAILED) {
            dispatch(
                NotificationActions.notification({
                    snackbarOpen: true,
                    snackbarType: "error",
                    snackbarMessage: "Oops something went wrong, try again.",
                })
            );
        }
    }, [dispatch, status]);

    return [status, autocomplations];
};

export default useSuggestedChoices;
